import styled from "styled-components";
import {SearchInputAreaDefaultBox} from "./search-input-area.default.box";

export const SearchInputAreaCasino888WsopBox = styled(SearchInputAreaDefaultBox)`
    
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        font-weight: 600;
        padding: 0.90rem 1.8rem;
        width: 0;
        &:focus {
            width: 25rem;
            padding-left: 5rem;
        }
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1.4rem 1rem 1.4rem 5.7rem;
    }

`;
